export const formatDateTime = (value, options = {}) => {
  const { fallback = "—", ...formatOptions } = options;
  if (!value) return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;

  return new Intl.DateTimeFormat(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
    ...formatOptions,
  }).format(date);
};
